// @ts-nocheck
/* kvsche-skyline-product.js — product-page configurator for Skyline.
   Safe to load on any page: it only activates when a
   [data-kvsche-skyline-product] container is present in the DOM. */

(function () {
  'use strict';

  /* ────────────────────────────────────────────────────────────────
     § 1  DATA — pricing table (from skyline series.xlsx)
            silver = Brushed Aluminum tier
            premium = Dark Bronze / Matte Black / Brushed Gold tier
     ──────────────────────────────────────────────────────────────── */

  var SKYLINE_DATA = {
    single: [
      { ft: 6,    rows: 11, silver: 2043,  premium: 2393  },
      { ft: 6.5,  rows: 12, silver: 2213,  premium: 2588  },
      { ft: 7,    rows: 13, silver: 2383,  premium: 2758  },
      { ft: 7.5,  rows: 14, silver: 2554,  premium: 3004  },
      { ft: 8,    rows: 15, silver: 2724,  premium: 3174  },
      { ft: 8.5,  rows: 16, silver: 2894,  premium: 3394  },
      { ft: 9,    rows: 17, silver: 3064,  premium: 3564  },
      { ft: 9.5,  rows: 18, silver: 3235,  premium: 3785  },
      { ft: 10,   rows: 19, silver: 3405,  premium: 3955  },
      { ft: 10.5, rows: 20, silver: 3575,  premium: 4175  },
      { ft: 11,   rows: 21, silver: 3745,  premium: 4345  },
      { ft: 11.5, rows: 22, silver: 3916,  premium: 4566  },
      { ft: 12,   rows: 23, silver: 4086,  premium: 4736  },
      { ft: 12.5, rows: 24, silver: 4256,  premium: 4956  },
      { ft: 13,   rows: 25, silver: 4426,  premium: 5126  },
      { ft: 13.5, rows: 26, silver: 4597,  premium: 5347  },
      { ft: 14,   rows: 27, silver: 4767,  premium: 5517  },
    ],
    double: [
      { ft: 6,    rows: 11, silver: 2328,  premium: 3103  },
      { ft: 6.5,  rows: 12, silver: 2522,  premium: 3297  },
      { ft: 7,    rows: 13, silver: 2716,  premium: 3491  },
      { ft: 7.5,  rows: 14, silver: 2910,  premium: 3685  },
      { ft: 8,    rows: 15, silver: 3104,  premium: 3879  },
      { ft: 8.5,  rows: 16, silver: 3298,  premium: 4073  },
      { ft: 9,    rows: 17, silver: 3492,  premium: 4267  },
      { ft: 9.5,  rows: 18, silver: 3686,  premium: 4461  },
      { ft: 10,   rows: 19, silver: 3880,  premium: 4655  },
      { ft: 10.5, rows: 20, silver: 4074,  premium: 4849  },
      { ft: 11,   rows: 21, silver: 4268,  premium: 5043  },
      { ft: 11.5, rows: 22, silver: 4462,  premium: 5237  },
      { ft: 12,   rows: 23, silver: 4656,  premium: 5431  },
      { ft: 12.5, rows: 24, silver: 4850,  premium: 5625  },
      { ft: 13,   rows: 25, silver: 5044,  premium: 5819  },
      { ft: 13.5, rows: 26, silver: 5238,  premium: 6013  },
      { ft: 14,   rows: 27, silver: 5432,  premium: 6207  },
    ],
  };

  var SKYLINE_FINISHES = [
    { id: 'aluminum', name: 'Brushed Aluminum',    short: 'Aluminum',    tier: 'silver',  tint: '#C8C4BE', railTint: '#A8A39C' },
    { id: 'bronze',   name: 'Dark Bronze',         short: 'Bronze',      tier: 'premium', tint: '#8F6D55', railTint: '#6A4F3A' },
    { id: 'black',    name: 'Brushed Matte Black', short: 'Matte Black', tier: 'premium', tint: '#2E2A28', railTint: '#1C1A18' },
    { id: 'gold',     name: 'Brushed Gold',        short: 'Gold',        tier: 'premium', tint: '#C8AA6E', railTint: '#9C8045' },
  ];

  var SKYLINE_CONFIGS = [
    {
      id: 'single', name: 'Single Skyline', short: 'Single', bottlesPerRow: 1,
      blurb: 'One bottle per row. A single architectural column — for narrow walls, alcoves and curated collections.',
    },
    {
      id: 'double', name: 'Double Skyline', short: 'Double', bottlesPerRow: 2,
      blurb: 'Two bottles per row. Twice the capacity, equally architectural — for serious collectors and statement walls.',
    },
  ];

  /* ────────────────────────────────────────────────────────────────
     § 2  HELPERS — pricing, unit conversion, formatting
     ──────────────────────────────────────────────────────────────── */

  function skylineRow(configId, ft) {
    var rows = SKYLINE_DATA[configId];
    var clamped = Math.max(6, Math.min(14, Math.round(ft * 2) / 2));
    return rows.find(function (r) { return r.ft === clamped; }) || rows[0];
  }

  function skylinePrice(configId, finishId, ft) {
    var finish = SKYLINE_FINISHES.find(function (f) { return f.id === finishId; });
    var row = skylineRow(configId, ft);
    return finish.tier === 'silver' ? row.silver : row.premium;
  }

  function skylineBottles(configId, ft) {
    var cfg = SKYLINE_CONFIGS.find(function (c) { return c.id === configId; });
    var row = skylineRow(configId, ft);
    return row.rows * cfg.bottlesPerRow;
  }

  /* ft decimal → { ft, in } pair */
  function ftDecimalToFtIn(ftDec) {
    var totalIn = Math.round(ftDec * 12);
    return { ft: Math.floor(totalIn / 12), in: totalIn % 12 };
  }

  /* { ft, in } → ft decimal */
  function ftInToFtDec(ft, inch) {
    return (ft || 0) + (inch || 0) / 12;
  }

  function ftToMm(ftDec) { return Math.round(ftDec * 304.8); }
  function mmToFt(mm)    { return mm / 304.8; }

  function money(cents) {
    var value = Number(cents || 0) / 100;
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
  }

  function setTextAll(selector, value) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.textContent = value;
    });
  }

  /* ────────────────────────────────────────────────────────────────
     § 3  STATE
     ──────────────────────────────────────────────────────────────── */

  var state = { configId: 'single', finishId: 'bronze', ft: 8, unit: 'ftin' };

  /* Shopify product JSON exposed by the Liquid template via window.KVSCHE_SKYLINE_PRODUCT.
     Used to map the selected finish to a real Shopify variant ID. */
  var KVSCHE_SKYLINE_PRODUCT = window.KVSCHE_SKYLINE_PRODUCT || null;

  function normalizeOpt(val) {
    return (val || '').toString().trim().toLowerCase();
  }

  function findVariantForSelection() {
    if (!KVSCHE_SKYLINE_PRODUCT || !KVSCHE_SKYLINE_PRODUCT.variants) return null;
    var finish = SKYLINE_FINISHES.find(function (f) { return f.id === state.finishId; });
    var cfg    = SKYLINE_CONFIGS.find(function (c) { return c.id === state.configId; });
    if (!finish || !cfg) return null;

    /* Match against the REAL Shopify option values:
         Configuration → "Single Skyline" / "Double Skyline"  (cfg.name)
         Finish        → "Aluminum" / "Bronze" / "Matte Black" / "Gold"  (finish.short)
         Height        → "6", "6.5", … "14"  (plain feet)
       We also accept the bare "single"/"double" and the full finish name so the
       matcher keeps working if those option labels are ever shortened/renamed. */
    var wantConfig      = normalizeOpt(cfg.name);     /* single skyline | double skyline */
    var wantConfigShort = normalizeOpt(cfg.short);    /* single | double                 */
    var wantFinish      = normalizeOpt(finish.short); /* aluminum | bronze | matte black | gold */
    var wantFinishFull  = normalizeOpt(finish.name);  /* brushed aluminum | dark bronze | … */
    var wantHeight      = state.ft;                   /* numeric, so "8" and "8.0" both match   */

    /* Order-independent: we don't assume Configuration/Finish/Height are
       option1/2/3 — we just require all three to appear among the variant's
       option values. */
    for (var i = 0; i < KVSCHE_SKYLINE_PRODUCT.variants.length; i++) {
      var v = KVSCHE_SKYLINE_PRODUCT.variants[i];
      var opts = v.options || [v.option1, v.option2, v.option3];
      var hasConfig = false, hasFinish = false, hasHeight = false;
      for (var j = 0; j < opts.length; j++) {
        var o = normalizeOpt(opts[j]);
        if (o === wantConfig || o === wantConfigShort) hasConfig = true;
        else if (o === wantFinish || o === wantFinishFull) hasFinish = true;
        else if (parseFloat(o) === wantHeight) hasHeight = true;
      }
      if (hasConfig && hasFinish && hasHeight) return v;
    }
    return null;
  }

  function fallbackPriceCents() {
    return skylinePrice(state.configId, state.finishId, state.ft) * 100;
  }

  function applyVariantToForm(variant) {
    var form = document.querySelector('.sl-product-form');
    var idInput = form && form.querySelector('input[name="id"]');
    var idSelect = form && form.querySelector('select[name="id"]');
    var addBtn = document.querySelector('[data-sl-add-cart]');
    var labelEl = addBtn && addBtn.querySelector('[data-sl-add-cart-label]');
    var unavailable = !variant || variant.available === false;

    if (idInput && variant) idInput.value = variant.id;
    if (idSelect && variant) idSelect.value = variant.id;

    if (addBtn) {
      addBtn.disabled = unavailable;
      addBtn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      addBtn.classList.toggle('is-unavailable', unavailable);
    }
    if (labelEl) {
      labelEl.textContent = unavailable ? 'Unavailable' : (addBtn.dataset.slAddLabel || 'Add to cart');
    }
  }

  /* ────────────────────────────────────────────────────────────────
     § 4  SVG RACK PREVIEW — rebuilds every time state changes
     ──────────────────────────────────────────────────────────────── */

  function bottleHtml(sx, cy) {
    var bottleLen = 305, bodyLen = 175, shoulder = 30, neckLen = 70, capLen = 30;
    var bodyRad = 38, neckRad = 13, capRad = 15;
    var half         = bottleLen / 2;
    var bodyLeft     = sx - half;
    var bodyRight    = bodyLeft + bodyLen;
    var shoulderRight = bodyRight + shoulder;
    var neckRight    = shoulderRight + neckLen;

    var path =
      'M ' + (bodyLeft + 14) + ' ' + (cy - bodyRad) +
      ' L ' + bodyRight + ' ' + (cy - bodyRad) +
      ' C ' + (bodyRight + shoulder * 0.6) + ' ' + (cy - bodyRad) + ',' +
              (shoulderRight - shoulder * 0.2) + ' ' + (cy - neckRad - 1) + ',' +
              shoulderRight + ' ' + (cy - neckRad) +
      ' L ' + neckRight + ' ' + (cy - neckRad) +
      ' L ' + neckRight + ' ' + (cy + neckRad) +
      ' L ' + shoulderRight + ' ' + (cy + neckRad) +
      ' C ' + (shoulderRight - shoulder * 0.2) + ' ' + (cy + neckRad + 1) + ',' +
              (bodyRight + shoulder * 0.6) + ' ' + (cy + bodyRad) + ',' +
              bodyRight + ' ' + (cy + bodyRad) +
      ' L ' + (bodyLeft + 14) + ' ' + (cy + bodyRad) +
      ' A 14 14 0 0 1 ' + (bodyLeft + 14) + ' ' + (cy - bodyRad) + ' Z';

    return (
      '<path d="' + path + '" fill="url(#sl-bottle-glass)" stroke="none" stroke-linejoin="round"/>' +
      '<rect x="' + (bodyLeft + 16) + '" y="' + (cy - bodyRad * 0.85) + '"' +
        ' width="' + (bodyLen - 24) + '" height="' + (bodyRad * 1.7) + '"' +
        ' fill="url(#sl-bottle-shine)" rx="2" pointer-events="none"/>' +
      '<rect x="' + (bodyLeft + bodyLen * 0.20) + '" y="' + (cy - bodyRad * 0.7) + '"' +
        ' width="' + (bodyLen * 0.55) + '" height="' + (bodyRad * 1.4) + '"' +
        ' fill="#EFE5D0" stroke="rgba(0,0,0,0.06)" stroke-width="0.5" rx="1"/>' +
      '<line x1="' + (bodyLeft + bodyLen * 0.22) + '" y1="' + (cy + bodyRad * 0.5) + '"' +
        ' x2="' + (bodyLeft + bodyLen * 0.72) + '" y2="' + (cy + bodyRad * 0.5) + '"' +
        ' stroke="rgba(120,80,40,0.32)" stroke-width="0.6"/>' +
      '<circle cx="' + (bodyLeft + bodyLen * 0.30) + '" cy="' + (cy - bodyRad * 0.1) + '"' +
        ' r="2.2" fill="rgba(120,80,40,0.45)"/>' +
      '<rect x="' + (neckRight - 4) + '" y="' + (cy - capRad) + '"' +
        ' width="' + (capLen + 6) + '" height="' + (capRad * 2) + '"' +
        ' fill="url(#sl-cap-foil)" stroke="none" rx="1"/>' +
      '<rect x="' + (neckRight - 4) + '" y="' + (cy - capRad + capRad * 1.85) + '"' +
        ' width="' + (capLen + 6) + '" height="1.5" fill="rgba(0,0,0,0.35)"/>' +
      '<ellipse cx="' + sx + '" cy="' + (cy + bodyRad + 2.5) + '"' +
        ' rx="' + (bottleLen * 0.40) + '" ry="1.4" fill="rgba(0,0,0,0.18)" pointer-events="none"/>'
    );
  }

  function renderSVG() {
    var cfg     = SKYLINE_CONFIGS.find(function (c) { return c.id === state.configId; });
    var finish  = SKYLINE_FINISHES.find(function (f) { return f.id === state.finishId; });
    var row     = skylineRow(state.configId, state.ft);
    var heightMm = ftToMm(state.ft);
    var postGap  = state.configId === 'double' ? 900 : 440;
    var padX = 240, padTop = 60, padBottom = 60;
    var vbW  = postGap + 220 + padX * 2;
    var vbH  = heightMm + padTop + padBottom;

    var anchorOffset = 60, rackTop = 110;
    var rackBottom = heightMm - 110;
    var usable  = rackBottom - rackTop;
    var rowGap  = usable / Math.max(1, row.rows - 1);
    var bodyRad = 38;
    var hw      = finish.railTint; /* hardware color — drives all post/rail/bracket tints */

    var cx           = vbW / 2;
    var postsX       = [cx - postGap / 2, cx + postGap / 2];
    var slotCenters  = cfg.bottlesPerRow === 1 ? [cx] : [cx - postGap / 4, cx + postGap / 4];

    var ftIn = ftDecimalToFtIn(state.ft);
    var dim  = state.unit === 'mm'
      ? ftToMm(state.ft).toLocaleString() + ' mm'
      : ftIn.ft + '′ ' + ftIn.in + '″';

    /* ruler foot marks */
    var ftMarks = [];
    for (var f = 1; f <= Math.floor(state.ft); f++) ftMarks.push(f);

    /* ── defs ── */
    var defs =
      '<defs>' +
        '<linearGradient id="sl-bottle-glass" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%"   stop-color="#1A1614"/>' +
          '<stop offset="38%"  stop-color="#0B0908"/>' +
          '<stop offset="62%"  stop-color="#0B0908"/>' +
          '<stop offset="100%" stop-color="#181412"/>' +
        '</linearGradient>' +
        '<linearGradient id="sl-bottle-shine" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%"   stop-color="rgba(255,255,255,0)"/>' +
          '<stop offset="45%"  stop-color="rgba(255,255,255,0.14)"/>' +
          '<stop offset="55%"  stop-color="rgba(255,255,255,0.18)"/>' +
          '<stop offset="100%" stop-color="rgba(255,255,255,0)"/>' +
        '</linearGradient>' +
        '<linearGradient id="sl-cap-foil" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%"   stop-color="#7C1F28"/>' +
          '<stop offset="60%"  stop-color="#5B141B"/>' +
          '<stop offset="100%" stop-color="#3C0D12"/>' +
        '</linearGradient>' +
        '<radialGradient id="sl-rack-shadow" cx="0.5" cy="0" r="0.6">' +
          '<stop offset="0%"   stop-color="rgba(28,25,21,0.22)"/>' +
          '<stop offset="60%"  stop-color="rgba(28,25,21,0.06)"/>' +
          '<stop offset="100%" stop-color="rgba(28,25,21,0)"/>' +
        '</radialGradient>' +
      '</defs>';

    /* ── floor shadow ── */
    var shadow =
      '<ellipse cx="' + cx + '" cy="' + (padTop + heightMm + 8) + '"' +
      ' rx="' + (postGap * 0.85) + '" ry="14" fill="url(#sl-rack-shadow)"/>';

    /* ── floor line ── */
    var floorY    = padTop + heightMm + 1;
    var floorLine =
      '<line x1="' + (padX - 40) + '" y1="' + floorY + '"' +
      ' x2="' + (vbW - (padX - 40)) + '" y2="' + floorY + '"' +
      ' stroke="rgba(157,147,136,0.30)" stroke-width="1.5"/>';

    /* ── left ruler ── */
    var rulerParts = [
      '<g transform="translate(' + (padX - 80) + ',' + padTop + ')" class="sl-preview__ruler">',
      '<line x1="0" y1="0" x2="0" y2="' + heightMm + '"' +
        ' stroke="rgba(157,147,136,0.30)" stroke-width="1.5"/>',
    ];
    ftMarks.forEach(function (fv) {
      var y = heightMm - ftToMm(fv);
      rulerParts.push(
        '<line x1="-8" y1="' + y + '" x2="0" y2="' + y + '"' +
          ' stroke="rgba(157,147,136,0.30)" stroke-width="1.5"/>',
        '<text x="-16" y="' + (y + 5) + '" text-anchor="end"' +
          ' class="sl-preview__ruler-label">' + fv + '′</text>'
      );
    });
    rulerParts.push(
      '<text x="-16" y="-12" text-anchor="end"' +
        ' class="sl-preview__ruler-label sl-preview__ruler-label--accent">' + dim + '</text>',
      '</g>'
    );
    var ruler = rulerParts.join('');

    /* ── posts ── */
    var posts = postsX.map(function (px) {
      return '<line x1="' + px + '" y1="0" x2="' + px + '" y2="' + heightMm + '"' +
        ' stroke="' + hw + '" stroke-width="2" stroke-linecap="square"/>';
    }).join('');

    /* ── top anchor brackets ── */
    var topAnchors = postsX.map(function (px) {
      return (
        '<g transform="translate(' + px + ',0)">' +
          '<rect x="-7" y="0" width="14" height="' + (anchorOffset - 12) + '" fill="' + hw + '" rx="2"/>' +
          '<rect x="-12" y="' + (anchorOffset - 12) + '" width="24" height="14" fill="' + hw + '" rx="3"/>' +
        '</g>'
      );
    }).join('');

    /* ── bottom anchor brackets ── */
    var botAnchors = postsX.map(function (px) {
      return (
        '<g transform="translate(' + px + ',' + heightMm + ')">' +
          '<rect x="-7" y="-' + (anchorOffset - 12) + '" width="14" height="' + (anchorOffset - 12) + '" fill="' + hw + '" rx="2"/>' +
          '<rect x="-12" y="-' + anchorOffset + '" width="24" height="14" fill="' + hw + '" rx="3"/>' +
        '</g>'
      );
    }).join('');

    /* ── bottle rows ── */
    var rowsHtml = '';
    for (var i = 0; i < row.rows; i++) {
      var y     = rackTop + i * rowGap;
      var delay = i * 28;

      var rails =
        '<line x1="' + postsX[0] + '" y1="' + (y - bodyRad + 2) + '"' +
          ' x2="' + postsX[1] + '" y2="' + (y - bodyRad + 2) + '"' +
          ' stroke="' + hw + '" stroke-width="1.6"/>' +
        '<line x1="' + postsX[0] + '" y1="' + (y + bodyRad - 2) + '"' +
          ' x2="' + postsX[1] + '" y2="' + (y + bodyRad - 2) + '"' +
          ' stroke="' + hw + '" stroke-width="1.6"/>' +
        postsX.map(function (px) {
          return '<rect x="' + (px - 4) + '" y="' + (y - bodyRad) + '"' +
            ' width="8" height="' + (bodyRad * 2) + '" fill="' + hw + '" rx="1"/>';
        }).join('');

      var bottles = slotCenters.map(function (sx) {
        return '<g>' + bottleHtml(sx, y) + '</g>';
      }).join('');

      rowsHtml +=
        '<g class="sl-preview__row" style="animation-delay:' + delay + 'ms">' +
        rails + bottles +
        '</g>';
    }

    return (
      '<svg class="sl-preview__svg"' +
      ' viewBox="0 0 ' + vbW + ' ' + vbH + '"' +
      ' preserveAspectRatio="xMidYMax meet"' +
      ' xmlns="http://www.w3.org/2000/svg"' +
      ' aria-label="' + cfg.name + ' in ' + finish.name + ' at ' + dim + '">' +
      defs + shadow + floorLine + ruler +
      '<g transform="translate(0,' + padTop + ')">' +
        posts + topAnchors + botAnchors +
        '<g class="sl-preview__rows">' + rowsHtml + '</g>' +
      '</g>' +
      '</svg>'
    );
  }

  /* ────────────────────────────────────────────────────────────────
     § 5  UI UPDATE — syncs every DOM node to the current state object
     ──────────────────────────────────────────────────────────────── */

  function updateUI() {
    var cfg     = SKYLINE_CONFIGS.find(function (c) { return c.id === state.configId; });
    var finish  = SKYLINE_FINISHES.find(function (f) { return f.id === state.finishId; });
    var row     = skylineRow(state.configId, state.ft);
    var variant = findVariantForSelection();
    var price   = variant ? variant.price : fallbackPriceCents();
    var bottles = skylineBottles(state.configId, state.ft);
    var ftIn    = ftDecimalToFtIn(state.ft);
    var mm      = ftToMm(state.ft);
    var pct     = ((state.ft - 6) / (14 - 6)) * 100;
    var heightLabel = state.unit === 'mm'
      ? mm.toLocaleString() + ' mm'
      : ftIn.ft + '′ ' + ftIn.in + '″';

    /* SVG rack preview */
    var stage = document.querySelector('.sl-preview__stage');
    if (stage) stage.innerHTML = renderSVG();

    /* Preview caption */
    var capL = document.querySelector('[data-sl-caption-l]');
    if (capL) capL.innerHTML = '<em>' + cfg.short + '</em> &middot; ' + finish.name;

    /* Intro meta line */
    var introMeta = document.querySelector('[data-sl-intro-meta]');
    if (introMeta) {
      introMeta.innerHTML =
        '<em>' + cfg.short + '</em> &middot; <em>' + finish.short + '</em> &middot; floor-to-ceiling';
    }

    /* Header price block */
    var priceNow  = document.querySelector('[data-sl-price-now]');
    var priceRows = document.querySelector('[data-sl-price-rows]');
    if (priceNow)  priceNow.textContent  = money(price);
    if (priceRows) priceRows.textContent = '· ' + row.rows + ' rows · ' + bottles + ' bottles';

    /* Step value labels (right-aligned current selection text) */
    var cfgVal = document.querySelector('[data-sl-cfg-value]');
    var finVal = document.querySelector('[data-sl-fin-value]');
    var htVal  = document.querySelector('[data-sl-ht-value]');
    if (cfgVal) cfgVal.innerHTML = '<em>' + cfg.name + '</em>';
    if (finVal) finVal.innerHTML = '<em>' + finish.name + '</em>';
    if (htVal) {
      htVal.innerHTML = '<em>' + heightLabel + '</em>';
    }

    setTextAll('[data-sl-mobile-config]', cfg.short);
    setTextAll('[data-sl-mobile-finish]', finish.short);
    setTextAll('[data-sl-mobile-height]', heightLabel);
    setTextAll('[data-sl-mobile-price]', money(price));

    /* Config tile aria-pressed */
    document.querySelectorAll('[data-sl-config-tile]').forEach(function (tile) {
      tile.setAttribute('aria-pressed', tile.dataset.slConfigTile === state.configId ? 'true' : 'false');
    });

    /* Finish tile aria-pressed */
    document.querySelectorAll('[data-sl-finish-tile]').forEach(function (tile) {
      tile.setAttribute('aria-pressed', tile.dataset.slFinishTile === state.finishId ? 'true' : 'false');
    });

    /* Height inputs — show/hide ft·in vs mm groups */
    var ftInput = document.querySelector('[data-sl-ft-input]');
    var inInput = document.querySelector('[data-sl-in-input]');
    var mmInput = document.querySelector('[data-sl-mm-input]');
    var ftGroup = document.querySelector('[data-sl-ftin-group]');
    var mmGroup = document.querySelector('[data-sl-mm-group]');

    if (state.unit === 'mm') {
      if (ftGroup) ftGroup.style.display = 'none';
      if (mmGroup) mmGroup.style.display = '';
      if (mmInput) mmInput.value = mm;
    } else {
      if (ftGroup) ftGroup.style.display = '';
      if (mmGroup) mmGroup.style.display = 'none';
      if (ftInput) ftInput.value = ftIn.ft;
      if (inInput) inInput.value = ftIn.in;
    }

    /* Unit toggle button states */
    document.querySelectorAll('[data-sl-unit-btn]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.slUnitBtn === state.unit ? 'true' : 'false');
    });

    /* Custom slider — fill bar + thumb position */
    var sliderInput = document.querySelector('[data-sl-slider]');
    var sliderFill  = document.querySelector('[data-sl-slider-fill]');
    var sliderThumb = document.querySelector('[data-sl-slider-thumb]');
    if (sliderInput) sliderInput.value       = state.ft;
    if (sliderFill)  sliderFill.style.transform = 'scaleX(' + (pct / 100) + ')';
    if (sliderThumb) sliderThumb.style.left  = pct + '%';

    /* Height meta: rows + bottle count */
    var metaRows    = document.querySelector('[data-sl-meta-rows]');
    var metaBottles = document.querySelector('[data-sl-meta-bottles]');
    if (metaRows)    metaRows.textContent    = row.rows;
    if (metaBottles) metaBottles.textContent = bottles;

    /* Summary price */
    var sumPrice = document.querySelector('[data-sl-summary-price]');
    if (sumPrice) sumPrice.textContent = money(price);

    applyVariantToForm(variant);

    /* Specifications section — dynamic rows */
    var finishDescMap = {
      aluminum: 'Brushed Aluminum · powder-coated extruded aluminium',
      bronze:   'Dark Bronze · powder-coated extruded aluminium',
      black:    'Brushed Matte Black · powder-coated extruded aluminium',
      gold:     'Brushed Gold · Anodized Solid Aluminium',
    };
    var spacingMap = { single: '~100 mm between rails', double: '~130 mm between rails' };

    var specConfig  = document.querySelector('[data-sl-spec-config]');
    var specFinish  = document.querySelector('[data-sl-spec-finish]');
    var specSpacing = document.querySelector('[data-sl-spec-spacing]');
    var specCap     = document.querySelector('[data-sl-spec-capacity]');
    if (specConfig)  specConfig.textContent  = cfg.name;
    if (specFinish)  specFinish.textContent  = finishDescMap[state.finishId] || finish.name;
    if (specSpacing) specSpacing.textContent = spacingMap[state.configId] || '';
    if (specCap)     specCap.textContent     =
      row.rows + ' rows · ' + bottles + ' standard 750 ml bottles';
  }

  function showToast(msg) {
    var existing = document.querySelector('.sl-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'sl-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = msg;
    (document.querySelector('[data-kvsche-skyline-product]') || document.body).appendChild(toast);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 3400);
  }

  /* ────────────────────────────────────────────────────────────────
     § 7  SCROLL REVEAL — IntersectionObserver for .kv-reveal elements
     ──────────────────────────────────────────────────────────────── */

  function initReveal() {
    var els = document.querySelectorAll('[data-kvsche-skyline-product] .kv-reveal:not(.in)');
    if (!('IntersectionObserver' in window) || els.length === 0) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ────────────────────────────────────────────────────────────────
     § 8  EVENT WIRING — all listeners are DELEGATED from the page
            container, so they keep working even if Shopify re-renders
            child nodes (theme editor) or the DOM changes.
     ──────────────────────────────────────────────────────────────── */

  function clampFt(ftDec) {
    return Math.max(6, Math.min(14, Math.round(ftDec * 2) / 2));
  }

  function wire(container) {
    /* Clicks — config tiles, finish tiles, unit toggle, add-to-cart */
    container.addEventListener('click', function (e) {
      var cfg = e.target.closest('[data-sl-config-tile]');
      if (cfg) { state.configId = cfg.dataset.slConfigTile; updateUI(); return; }

      var fin = e.target.closest('[data-sl-finish-tile]');
      if (fin) { state.finishId = fin.dataset.slFinishTile; updateUI(); return; }

      var unitBtn = e.target.closest('[data-sl-unit-btn]');
      if (unitBtn) { state.unit = unitBtn.dataset.slUnitBtn; updateUI(); return; }

      var add = e.target.closest('[data-sl-add-cart]');
      if (add && add.disabled) {
        e.preventDefault();
        showToast('This configuration is currently unavailable.');
        return;
      }
    });

    /* Slider drag — live update */
    container.addEventListener('input', function (e) {
      var slider = e.target.closest('[data-sl-slider]');
      if (slider) { state.ft = clampFt(parseFloat(slider.value)); updateUI(); }
    });

    /* Number inputs — feet / inches / millimetres */
    container.addEventListener('change', function (e) {
      var ftInput = e.target.closest('[data-sl-ft-input]');
      if (ftInput) {
        var curA = ftDecimalToFtIn(state.ft);
        var newFt = parseInt(ftInput.value, 10);
        if (!isNaN(newFt)) { state.ft = clampFt(ftInToFtDec(newFt, curA.in)); updateUI(); }
        return;
      }
      var inInput = e.target.closest('[data-sl-in-input]');
      if (inInput) {
        var curB = ftDecimalToFtIn(state.ft);
        var newIn = parseInt(inInput.value, 10);
        if (!isNaN(newIn)) { newIn = Math.max(0, Math.min(11, newIn)); state.ft = clampFt(ftInToFtDec(curB.ft, newIn)); updateUI(); }
        return;
      }
      var mmInput = e.target.closest('[data-sl-mm-input]');
      if (mmInput) {
        var newMm = parseInt(mmInput.value, 10);
        if (!isNaN(newMm)) { state.ft = clampFt(mmToFt(newMm)); updateUI(); }
        return;
      }
    });

    container.addEventListener('submit', function (e) {
      var form = e.target.closest('.sl-product-form');
      if (!form) return;
      var variant = findVariantForSelection();
      if (!variant || variant.available === false) {
        e.preventDefault();
        showToast('This configuration is currently unavailable.');
        applyVariantToForm(variant);
      } else {
        var cfg = SKYLINE_CONFIGS.find(function (c) { return c.id === state.configId; });
        var finish = SKYLINE_FINISHES.find(function (f) { return f.id === state.finishId; });
        var ftIn = ftDecimalToFtIn(state.ft);
        showToast((cfg ? cfg.short : 'Skyline') + ' · ' + (finish ? finish.short : 'Finish') + ' · ' + ftIn.ft + '′ ' + ftIn.in + '″ added.');
      }
    });
  }

  /* ────────────────────────────────────────────────────────────────
     § 9  BOOT — idempotent. Runs on DOM ready, and re-runs in the
            Shopify theme editor when the section is (re)loaded.
     ──────────────────────────────────────────────────────────────── */

  function init() {
    var container = document.querySelector('[data-kvsche-skyline-product]');
    if (!container) return;                 /* not on the Skyline page */
    if (container.dataset.slInit === '1') { /* already wired — just refresh */
      updateUI();
      return;
    }
    container.dataset.slInit = '1';
    container.setAttribute('data-sl-booted', '1');

    /* Apply ?config=single|double from URL query param (nav dropdown deep-links) */
    var qsConfig = new URLSearchParams(window.location.search).get('config');
    if (qsConfig === 'single' || qsConfig === 'double') {
      state.configId = qsConfig;
    }

    /* Re-read the Shopify product JSON in case it loaded after this script */
    KVSCHE_SKYLINE_PRODUCT = window.KVSCHE_SKYLINE_PRODUCT || KVSCHE_SKYLINE_PRODUCT;

    wire(container);
    updateUI();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor: section added / reloaded */
  document.addEventListener('shopify:section:load', init);

  /* Native cross-document view transitions: re-init on reveal */
  window.addEventListener('pageshow', init);

})();
